import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";

export const useNotificationStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
      width : 1200
    },
      headerWrapper: {
      flexDirection: "row",
      alignItems: "center",
      marginTop: 10,
      justifyContent: "space-between",
    },
    headerTextRight: {
      marginRight: 40,
      alignSelf: "center",
      textAlign: "center",
    },
    centerDivider: {
      backgroundColor: AppColors.grayColor_282828,
      height: 2,
    },
    itemStyle: {
      marginVertical: 5,
    },
    itemTextWrapper: {
      alignSelf: "center",
      gap: 5,
      marginStart: 35,
      marginEnd: 35,
    },
    itemLeft: {
      flexDirection: "row",
      flex: 1.5,
    },
    itemRight: {
      //
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    buttonStyle: {
      borderRadius: 10,
      height: 36,
      width: 215,
      flexDirection: "row",
      gap: 8,
      justifyContent: "center",
      alignItems: "center",
    },
    selectOpponentButtonStyle: {
      borderRadius: 10,
      height: 25,
      width: 150,
      flexDirection: "row",
      gap: 8,
      justifyContent: "center",
      alignItems: "center",
    },
    itemWrapper: {
      flexDirection: "row",
      paddingVertical: 12,
      flexWrap: "wrap",
      gap: 20,
    },
    iveOrganizedButtonStyle: {
      height: 40,
      borderRadius: 10,
      borderWidth: 1,
      // backgroundColor: AppColors.gray_C3C3C3
    },
    challengesButtonStyle: {
      height: 40,
      paddingHorizontal: 30,
      paddingVertical: 12,
      borderRadius: 10,
      // backgroundColor: AppColors.appViolentColor_6D08C3 ,
      borderWidth: 1,
    },
    beltsRankingView: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      width: "100%",
      borderRadius: 10,
      padding: 15,
      gap: 10,
    },
    deviceFlexDirection: {
      flexDirection: "row",
    },
    challengeListFlexDirection: {
      flexDirection: "row",
    },
    IHaveOrganizedDirection: {
      flexDirection: "column",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextRight: {
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        //
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      selectOpponentButtonStyle: {
        borderRadius: 10,
        height: 25,
        width: 150,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
      iveOrganizedButtonStyle: {
        height: 40,
        borderRadius: 10,
        borderWidth: 1,
        // backgroundColor: AppColors.gray_C3C3C3
      },
      challengesButtonStyle: {
        height: 40,
        paddingHorizontal: 30,
        paddingVertical: 12,
        borderRadius: 10,
        // backgroundColor: AppColors.appViolentColor_6D08C3 ,
        borderWidth: 1,
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      deviceFlexDirection: {
        flexDirection: "column",
      },
      challengeListFlexDirection: {
        flexDirection: "column-reverse",
      },
      IHaveOrganizedDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextRight: {
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        //
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      selectOpponentButtonStyle: {
        borderRadius: 10,
        height: 25,
        width: 150,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
      iveOrganizedButtonStyle: {
        height: 40,
        borderRadius: 10,
        borderWidth: 1,
        // backgroundColor: AppColors.gray_C3C3C3
      },
      challengesButtonStyle: {
        height: 40,
        paddingHorizontal: 30,
        paddingVertical: 12,
        borderRadius: 10,
        // backgroundColor: AppColors.appViolentColor_6D08C3 ,
        borderWidth: 1,
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      deviceFlexDirection: {
        flexDirection: "column",
      },
      challengeListFlexDirection: {
        flexDirection: "column-reverse",
      },
      IHaveOrganizedDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextRight: {
        marginRight: 0,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        //
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      selectOpponentButtonStyle: {
        borderRadius: 10,
        height: 25,
        width: 150,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
      iveOrganizedButtonStyle: {
        height: 40,
        borderRadius: 10,
        borderWidth: 1,
        // backgroundColor: AppColors.gray_C3C3C3
      },
      challengedButtonStyle: {
        height: 40,
        paddingHorizontal: 30,
        paddingVertical: 12,
        borderRadius: 10,
        // backgroundColor: AppColors.appViolentColor_6D08C3 ,
        borderWidth: 1,
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      deviceFlexDirection: {
        flexDirection: "column",
      },
      challengeListFlexDirection: {
        flexDirection: "column-reverse",
      },
      IHaveOrganizedDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
        // paddingHorizontal: 0,
        // paddingTop: 0,
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextRight: {
        marginRight: 0,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        //
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      selectOpponentButtonStyle: {
        borderRadius: 10,
        height: 25,
        width: 150,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
      iveOrganizedButtonStyle: {
        height: 40,
        borderRadius: 10,
        borderWidth: 1,
        // backgroundColor: AppColors.gray_C3C3C3
      },
      challengesButtonStyle: {
        height: 40,
        paddingHorizontal: 30,
        paddingVertical: 12,
        borderRadius: 10,
        // backgroundColor: AppColors.appViolentColor_6D08C3 ,
        borderWidth: 1,
      },
      beltsRankingView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        padding: 15,
        gap: 10,
      },
      deviceFlexDirection: {
        flexDirection: "column",
      },
      challengeListFlexDirection: {
        flexDirection: "column-reverse",
      },
      IHaveOrganizedDirection: {
        flexDirection: "column",
      },
    },
  }
);
